<template>
	<div id="enterprise_detail" v-title :data-title="companyinfor.name"> 
		<leftnav class="fl"></leftnav>
		<div :class="userdata.userType ==1?'':'indexcenterpage pagecontent'">
		<div class="enterprise_detail index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
		<!-- 	<p class="pageguide">
				<router-link to="/">首页</router-link>&gt;
			 <router-link to="/innovative-resources" target="_blank">{{guidepage}}</router-link>  &gt;<span>{{companyinfor.title}}</span>
			</p> -->		
				<govheader v-if="userdata.userType==1"></govheader>
			<div :class="userdata.userType ==1?'index_left_centerpage':''"> 
			<div class="whitebox" :class="userdata.userType == 2?'centerpage':''"> 
					<div class="d_blocktitle">
						<i class="title-icon title-icon1"></i>
						<h3 class="ctitle">{{companyinfor.title}}</h3>
						<span :class="companyinfor.status == '注销'?'fl companystatus cancellation':'fl companystatus '">{{companyinfor.status}}</span>
						<span :class="companyinfor.collectId == 0?'collectbtn add fr':'collectbtn remove fr'" @click="collectFun()">{{companyinfor.collectId == 0?'+添加关注':'取消关注'}}</span>
					</div>
					<p class="companyinfor oh">
						<span class="fl"><i>注册资本：</i><em>{{companyinfor.regCapital}}</em> </span>
						<span class="fl"><i>企业类型：</i><em>{{companyinfor.type}}</em> </span>
						<span class="fl"><i>组织机构代码：</i><em>{{companyinfor.orgCode}}</em> </span>
					</p>
					<p class="companyinfor oh">
						<span class="fl"><i>注册号：</i><em>{{companyinfor.regNo}}</em> </span><span
							class="fl"><i>纳税人识别号：</i><em>{{companyinfor.taxNo}}</em> </span><span
							class="fl"><i>员工人数：</i><em>{{companyinfor.insurePerson}}</em> </span>
					</p>
					<p class="companyinfor oh">
						<span class="fl"><i>所属行业：</i><em>{{companyinfor.industry}}</em> </span>
						<span class="fl" v-if="companyinfor.category!=''"><i>类别：</i><em>{{companyinfor.category}}</em> </span>
						<span class="fl"  v-if="companyinfor.level!=''"><i>级别：</i><em>{{companyinfor.level}}</em> </span>
					</p>
					<p class="companyinfor oneline" v-show="companyinfor.mainBusiness!=''" >
						<i>主营业务：</i><em>{{companyinfor.mainBusiness}}</em>
					</p>
					<p class="companyinfor oneline" v-show="companyinfor.businessScope!=''">
						<i>经营范围：</i><em>{{companyinfor.businessScope}}</em>
					</p> 
					<p class="companyinfor oneline" v-show="companyinfor.summary!=''">
						<i>企业介绍：</i><em>{{companyinfor.summary}}</em>
					</p> 
			</div>
			<div  class="ende_floorlist">
			<div class="ende_floorlistfixed">
				<ul class="oh">
						<li class="floorlistLi" @click="floorscroll(0)">联系方式</li>
						<li class="floorlistLi" @click="floorscroll(1)">研究院标签</li>
						<li class="floorlistLi" @click="floorscroll(2)" v-show="companyinfor.notion!=''">所属领域</li> 
						<li class="floorlistLi" @click="floorscroll(3)" v-show="shareholderlist.length>0">股东信息</li>
						<li class="floorlistLi" @click="floorscroll(4)" v-show="realController.length>0">实际控制人</li>
						<li class="floorlistLi" @click="floorscroll(5)" v-show="certificatelist.length>0">资质证书</li> 
						<li class="floorlistLi" @click="floorscroll(6)" v-show="companyinfor.patentNum>0">专利信息</li> 
						<li class="floorlistLi" @click="floorscroll(7)" v-show="patentlist.length>0">最新专利</li>  
						<li class="floorlistLi" @click="floorscroll(8)" v-show="controllEnterprise.length>0">控制企业</li> 
						<li class="floorlistLi" @click="floorscroll(9)" v-show="investlist.length>0">对外投资</li>    
					</ul> 
				</div>
			</div>
			<div class="whitebox company-contact	" :class="userdata.userType == 2?'centerpage':''"> 
				<div class=" d_blocktitle d-floortitle">
					<i class="title-icon title-icon2"></i>
					<h3 class="title">联系方式</h3>
				</div>
				<p class="companyinfor oh">
					<span class="fl"><i>法定代表人：</i><em>{{companyinfor.legalPerson}}</em> </span>
					<span class="fl"><i>联系电话：</i><em>{{companyinfor.phone}}</em> </span>
					<span class="fl"><i>更多电话：</i><em>{{companyinfor.morePhone}}</em>
					</span>
				</p>
				<p class="companyinfor oh">
					<span class="fl"><i>网 址：</i><em>{{companyinfor.website}}</em> </span>
					<span class="fl"><i>联系邮箱：</i><em>{{companyinfor.email}}</em> </span>
					<span class="fl"><i>更多邮箱：</i><em>{{companyinfor.moreEmail}}</em> </span>
				</p>
				<p class="companyinfor oneline">
					<i>企业地址：</i><em>{{companyinfor.address}}</em>
				</p> 
			</div>
			<div class="whitebox company-tags" :class="userdata.userType == 2?'centerpage':''"> 
				<div class=" d_blocktitle d-floortitle">
					<i class="title-icon title-icon3"></i>
					<h3 class="title">研究院标签</h3>
				</div>
				<div class="company_tag_list">
					<span class="span-tag" v-for="(item,i) in companyinfor.taglist" :key="'taglist'+i" @click="routerpage('/enterpriseTag?type=4&key=tag&id='+companyinfor.tagcodelist[i]+'&keyword='+item)">{{item}}</span>
					<span class="span-tag" v-if="companyinfor.tag == ''">暂无标签，添加中</span>
				</div> 
			</div>
			<div class="whitebox company-tags" v-show="companyinfor.notion!=''" :class="userdata.userType == 2?'centerpage':''">
				<div class=" d_blocktitle d-floortitle">
					<i class="title-icon title-icon3"></i>
					<h3 class="title">所属领域</h3>
				</div>
				<div class="company_tag_list">
					<span class="span-tag" v-for="(item,i) in companyinfor.notionlist" :key="'notionlist'+i" @click="routerpage('/enterpriseTag?type=4&key=notion&id='+companyinfor.notioncodelist[i]+'&keyword='+item)">{{item}}</span>
					<span class="span-tag" v-if="companyinfor.notion == ''">暂无标签，添加中</span>
				</div> 
			</div> 
			<div class="whitebox company-investinfor centerpage oh" v-show="shareholderlist.length>0">
				<div class=" d_blocktitle d-floortitle">
					<i class="title-icon title-icon4"></i>
					<h3 class="title">股东信息</h3>
				</div>
				<div class="w95mg oh">
				<table border="0" cellspacing="0" cellpadding="0" width="50%" class="pagetable1 fl">
					<tr>
						<th class="xuhaotd">序号</th>
						<th>股东及出资信息</th>
						<th>持股比例</th>
					</tr>
					<tr v-for="(item,index) in shareholderlist" :key="'enterprise'+index">
						<td>{{index+1}}</td>
						<td><span @click="detailrouterto('/investement-enterprises',item.stockCode)" :class="item.stockCode != '' ? 'curp':''" :data="item.stockCode">{{item.name}}</span></td>
						<td>{{item.value}}%</td>
					</tr>
				</table>
				<div class="fr" id="detail_sharholder" style="height:385px"></div> 
				<p style="clear: both;" v-show="companyinfor.isIpo">注：上市公司的小比例投资机构、散户投资者在表中不显示，故上表持股比例和低于100%。</p>
				</div>
			</div>
			<div class="whitebox company-investinfor centerpage oh" v-show="realController.length>0">
				<div class=" d_blocktitle d-floortitle">
					<i class="title-icon title-icon4"></i>
					<h3 class="title">实际控制人</h3>
				</div>
				<div class="oh">
					<p class="companyinforM oh" v-if="realController.length>0"> 
						<span class="fl"><i>疑似实际控制人：</i><em>{{realController[0].title}}</em></span> 
						<span class="fl"><i>总股权比例：</i><em>{{realController[0].proportion}}</em></span>  
					</p> 
				</div>
			</div>
			<div class="whitebox company-investinfor centerpage" v-show="certificatelist.length>0">
				<div class=" d_blocktitle d-floortitle">
					<i class="title-icon title-icon5"></i>
					<h3 class="title">资质证书</h3>
				</div>
				<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1">
					<tr>
						<th class="xuhaotd">序号</th>
						<th>证书类型</th>
						<th>证书名称</th>
						<th>证书编号</th>
						<th>发证日期</th>
						<th>截止日期</th>
					</tr>
					<tr v-for="(item,index) in certificatelist" :key="'certificatelist'+index">
						<td>{{index+1}}</td>
						<td>{{item.certType}}</td>
						<td class="toolongtd">{{item.certName}}</td>
						<td>{{item.certNo}}</td>
						<td>{{item.startDate}}</td>
						<td>{{item.endDate}}</td>
					</tr>
				</table> 
			</div>
			<div class="whitebox company-investinfor centerpage" v-show="companyinfor.patentNum>0">
				<div class=" d_blocktitle d-floortitle">
					<i class="title-icon title-icon6"></i>
					<h3 class="title">专利信息</h3>
				</div> 
				<div class="oh">  
					<p class="companyinforN oh companyinfor5"> 
						<span class="fl"><i>专利量：</i><em>{{companyinfor.patentNum}}</em></span> 
						<span class="fl"><i>发明（设计）人数量：</i><em>{{companyinfor.inventionNum}}</em></span> 
						<span class="fl"><i>有效专利量：</i><em>{{companyinfor.validPatentNum}}</em></span> 
						<span class="fl"><i>有效发明专利数量（件）：</i><em>{{companyinfor.validInventionNum}}</em></span> 
						<span class="fl"><i>有效实用新型数量（件）：</i><em>{{companyinfor.validPracticalNewTypeNum}}</em></span> 
					</p>
					<p class="companyinforN oh companyinfor5"> 
						<span class="fl"><i>有效外观设计数量（件）：</i><em>{{companyinfor.validFacadeDesignNum}}</em></span> 
						<span class="fl"><i>发明公开专利总量：</i><em>{{companyinfor.inventionPublicPatentNum}}</em></span> 
						<span class="fl"><i>外观设计专利总量：</i><em>{{companyinfor.facadeDesignPatentNum}}</em></span> 
						<span class="fl"><i>实用新型专利总量：</i><em>{{companyinfor.practicalNewTypePatentCount}}</em></span> 
					</p> 
				</div>
			</div>
			<div class="whitebox company-investinfor centerpage" v-show="patentlist.length>0">
				<div class=" d_blocktitle d-floortitle">
					<i class="title-icon title-icon6"></i>
					<h3 class="title">最新专利</h3>
				</div>
				<div :class="showzhuanlinum<patentlist.length?'demandlist_hide_table showmorenode':'demandlist_hide_table'"> 
					<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1">
						<tr>
							<th class="xuhaotd">序号</th>
							<th>发明名称</th>
							<th>专利类型</th>
							<th>法律状态</th>
							<th>申请号</th>
							<th>申请日</th>
							<th>公开(公告)号</th>
							<th>公开(公告)日期</th>
							<th>发明人</th>
						</tr>
						<tr v-for="(item,index) in patentlist" :key="'patent'+index" v-show="index < showzhuanlinum">
							<td>{{index+1}}</td>
							<td>{{item.title}}</td>
							<td>{{item.type}}</td>
							<td>{{item.legalStatus}}</td>
							<td>{{item.pubNo}}</td>
							<td>{{item.appDate}}</td>
							<td>{{item.appNo}}</td>
							<td>{{item.pubDate}}</td>
							<td>{{item.inventor}}</td>
						</tr>
					</table>
						<span v-text="showzhuanlinum>patentlist.length?'向上隐藏':'点击查看更多>>'" class="showmorenodebtn" @click="contorlpatent" v-show="patentlist.length>100"></span>
				</div>   
			</div>
			<div class="whitebox company-investinfor centerpage" v-show="controllEnterprise.length>0">
				<div class=" d_blocktitle d-floortitle">
					<i class="title-icon title-icon8"></i>
					<h3 class="title">控制企业</h3>
				</div>
				<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1">
					<tr>
						<th class="xuhaotd">序号</th>
						<th>控制企业</th>
						<th>投资比例</th>
						<th>投资链</th> 
					</tr>
					<tr v-for="(item,index) in controllEnterprise" :key="'controllEnterprise'+index">
						<td>{{index+1}}</td>
						<td>
							<span @click="detailrouterto('/enterprises',item.stockCode)" :class="item.stockCode != '' ? 'curp':''" :data="item.stockCode" style="white-space: nowrap;display: block;">{{item.title}}</span>
						</td>
						<td><span >{{item.proportion}}</span></td>
						<td>
							<span v-for="texts in item.investChainhtml" class="db tal" v-if="texts!=''" v-html="texts"></span>
						</td> 
					</tr> 
				</table> 
			</div> 
			<div class="whitebox company-investinfor centerpage" v-show="investlist.length>0">
				<div class=" d_blocktitle d-floortitle">
					<i class="title-icon title-icon8"></i>
					<h3 class="title">对外投资</h3>
				</div>
				<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1">
					<tr>
						<th class="xuhaotd">序号</th>
						<th>被投资企业名称</th>
						<th>法定代表人</th>
						<th>注册资本</th>
						<th>投资比例</th>
						<th>投资数额</th>
						<th>成立时间</th>
						<th>状态</th>
					</tr>
					<tr v-for="(item,index) in investlist" :key="'investlist'+index">
						<td>{{index+1}}</td>
						<td>
							<span @click="detailrouterto('/enterprises',item.stockCode)" :class="item.stockCode != '' ? 'curp':''" :data="item.stockCode">{{item.title}}</span>
						</td>
						<td>{{item.legalPerson}}</td>
						<td>{{item.regCapital}}</td>
						<td>{{item.proportion}}%</td>
						<td>{{item.investAmount}}</td>
						<td>{{item.createTime}}</td>
						<td>{{item.status}}</td>
					</tr> 
				</table> 
			</div> 
			</div>
		</div>
		</div>
		<footerbar v-if="userdata.userType>1"></footerbar>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'inresourcesDetail',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				curindex: 4,
				guidepage:'创新资源',
				userdata:{},
				enterpriseid: 0,
				leaderpage: "",
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#3975b8"],
				leaderpagetype: 0,
				companyinfor: { }, 
				certificatelist: [],
				patentlist: [],
				showzhuanlinum:100, 
				showzhuanlibtn:1,
				shareholderlist:[],  
				financing:{}, 
				controllEnterprise:[],
				realController:[], 
				investlist:[],
				yingyeshouru:{data:[],date:[]},
				netprofitlist:{data:[],date:[]},
				curstepp: 0,
				floorlist: ['联系方式', '研究院标签','专利信息'], 
				userheadname:[
					{type:1,name:'创新资源',curindex:4},
					{type:2,name:'创新资源',curindex:5},
					{type:3,name:'创新技术资源',curindex:4},
					{type:4,name:'创新技术资源',curindex:3},
					{type:5,name:'创新机构库',curindex:5},
					],
					issucss:true,
					addCRMid:0, scrollbtn:false,barHeight:60,
			}
		}, 
		beforeCreate() { },
		created() {
			this.$nextTick(() => {
					// 禁用右键
					document.oncontextmenu = new Function("event.returnValue=false");
					// 禁用选择
					document.onselectstart = new Function("event.returnValue=false");
			}); 
			// window.scrollTo(0,0);
			this.enterpriseid = this.$route.query.id; 
			this.leaderpagetype = this.$route.query.type * 1;
			var _this=this;
			this.userdata = this.getuseriformation(); 
			_this.getenterdetail(1); 
		},
		mounted() {
			window.scrollTo(0, 0); 
			window.addEventListener("scroll", this.handleScroll, true);
		 // this.testFloorTitle();
		},
		methods: {
			 
			//添加删除收藏
			collectFun(){
				// console.log(this.companyinfor.collectId,this.companyinfor);
				this.listToggleCollect(this.companyinfor,'acoc'); 
			},  
			contorlpatent(){
				// console.log(this.patentlist.length,this.showzhuanlinum);
				if(this.showzhuanlinum<this.patentlist.length){
					this.showzhuanlibtn++;
				}else{ 
					this.showzhuanlibtn=1;
				}
				this.showzhuanlinum=this.showzhuanlibtn*100;
			},
			getenterdetail(step){
				var _this=this;
				var ajaxurl=this.$api.cyl.academy.detail();
				if(step == 2){
					ajaxurl=this.$api.cyl.academy.detail2()
				}
				this.$axios.get(ajaxurl+"?id="+this.enterpriseid,{headers:{AuthToken:this.userdata.token}}).then(function(res){
					// console.log(res.data)
					if(res.data.success){  
								console.log(step,res.data);
								if(step == 1){
									document.title = res.data.data.title;
									_this.companyinfor=res.data.data;//基础信息 
									_this.companyinfor.taglist=[];
									if(_this.companyinfor.tag!=""){
										_this.companyinfor.taglist=_this.companyinfor.tag.split(',');
										_this.companyinfor.tagcodelist=_this.companyinfor.tagCode.split(',');
									}
									if(_this.companyinfor.notion!=""){
										_this.companyinfor.notionlist=_this.companyinfor.notion.split(',');
										_this.companyinfor.notioncodelist=_this.companyinfor.notionCode.split(',');
									}
										_this.bus.$emit('loading',false);
										_this.getenterdetail(2);
										console.log(_this.companyinfor.patentNum)
								}else if(step == 2){
									console.log(res.data.extend)
									var extendata=res.data.extend;
									_this.certificatelist=extendata.certificate;//证书信息
									_this.investlist=extendata.invest;//投资信息   
									_this.shareholderlist=extendata.shareholder;//股东信息   
									_this.patentlist=extendata.patent;//发明专利信息
									_this.controllEnterprisefun(extendata.controllEnterprise);//控制企业
									_this.realController=extendata.realController;//实际控制人
									if(_this.shareholderlist.length>0){
										_this.shareholderPie('detail_sharholder');
									}
									setTimeout(function(){
										_this.barHeight=document.getElementsByClassName('ende_floorlist')[0].offsetHeight;
										console.log(_this.barHeight)
									},1000)
								} 
								_this.scrollbtn=true;
					}else{ 
					} 
				}).catch(function (error) {  });  
			},
			controllEnterprisefun(data){
				var companyname=this.companyinfor.title;
				for(var i=0;i<data.length;i++){
					let tds=data[i].investChain; 
					data[i].investChainhtml=tds.split('路径');
					for(var d=0;d<data[i].investChainhtml.length;d++){
						if(data[i].investChainhtml[d]!=""){
							let ddsttss=data[i].investChainhtml[d];
							ddsttss="<b>路径"+ddsttss;
							var indst=ddsttss.indexOf(companyname);
							data[i].investChainhtml[d]=ddsttss.slice(0, indst) + '</b>' + ddsttss.slice(indst); 
						} 
					}
					
				} 
				// console.log(data[4]);
				this.controllEnterprise=data;
			},
			
			shareholderPie($el) {
				var chart = echarts.init(document.getElementById($el)); 
				var _this = this;
				let option = {
					title: {
						text: '股东持股比例',
						textStyle: {
							fontStyle: "normal",
							fontWeight: "normal",
							fontSize: 16,
						},
						left: "center",
						bottom: 10,
					},
			
					color: _this.colors,
					tooltip: {
						trigger: 'item',
						backgroundColor: 'rgba(255,255,255,0.9)',
						borderColor: '#ddd',
						borderWidth: '1',
						textStyle: {
							color: '#000',
							fontSize: 14,
						},
						formatter: function(params) { 
							let rethtml = params.marker + params.name + "</br>持股比例：" + params.value + "%";
							return rethtml;
						}
					},
					legend: {
						orient: 'vertical',
						left: 'left',
						show: false,
					},
			
					labelLine: {
						show: false
					},
					series: [{
						name: '',
						type: 'pie',
						radius: '70%',
						top: -40,
						label: {
							show: false,
							position: 'center'
						},
						avoidLabelOverlap: false,
						data: _this.shareholderlist,
						emphasis: {
							show: false,
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				};
				chart.setOption(option);
			}, 
			//测试title的问题
			testFloorTitle(){
					console.log(document.getElementsByClassName('d-floortitle').length,document.getElementsByClassName('floorlistLi').length)
				for(var i=0;i<document.getElementsByClassName('d-floortitle').length;i++){
					console.log(document.getElementsByClassName('d-floortitle')[i],document.getElementsByClassName('floorlistLi')[i]);
				}
			},
				handleScroll: function(e) { 
					if(!this.scrollbtn){return}; 
					var enflolength=document.getElementsByClassName('ende_floorlistfixed').length;
					// console.log('enflolength1',enflolength)
					if(enflolength<1){return;}
					var sctop = document.documentElement.scrollTop; 
					var bartop=document.getElementsByClassName('ende_floorlist')[0].offsetTop; 
					// console.log(sctop,bartop);
					if(sctop<bartop){
						document.getElementsByClassName('ende_floorlistfixed')[0].className="ende_floorlistfixed";
					}else{
						document.getElementsByClassName('ende_floorlistfixed')[0].className="ende_floorlistfixed fixedbox";
						var lengtsd=document.getElementsByClassName('floorlistLi').length; 
						// console.log(lengtsd,document.getElementsByClassName('d-floortitle').length )
						for(var i=0;i<lengtsd;i++){
							// console.log(document.getElementsByClassName('d-floortitle')[i],document.getElementsByClassName('d-floortitle')[i+1])
						 var top1=document.getElementsByClassName('d-floortitle')[i].offsetTop-this.barHeight;
							if(i<lengtsd-1){  
								var top2=document.getElementsByClassName('d-floortitle')[i+1].offsetTop-this.barHeight;
								if(top1>0 && top2>0 && sctop>top1 && sctop<top2){
									this.floorscroll(i,'scroll');
								} 
							}else if(i == lengtsd -1){ 
								if(top1>0 && sctop>top1){
									this.floorscroll(i,'scroll');
								}  
							}  
						}; 
					} 
				}, 
				floorscroll(indexs,type) {  
					// console.log(indexs,type);
					var oftop=document.getElementsByClassName('d-floortitle')[indexs].offsetTop-this.barHeight+6;
					var lengtsd=document.getElementsByClassName('floorlistLi').length;
					console.log(document.getElementsByClassName('d-floortitle')[indexs].outerHTML);
					for(var i=0;i<lengtsd;i++){
						var classNameaf="floorlistLi";
						if(i == indexs){
						 classNameaf="floorlistLi current";
						} 
						document.getElementsByClassName('floorlistLi')[i].className=classNameaf;
					}
					if(type != 'scroll'){
						// console.log('非',type,oftop);
						window.scrollTo(0, oftop);
					} 
					if(type == 'test'){
						this.testFloorTitle();
						// console.log(this.riskinfobtn,this.eqpledgeBtn)
					}
				},  
			routerpage(path){
				let routeUrl = this.$router.resolve({path: path});
				window.open(routeUrl.href, '_blank'); 
			}, 
		}
	}
</script>

<style>
</style>
